import React, { FC, ReactNode, useContext } from "react";
import Head from "next/head";
import { AppContext } from "context/app";
import { SimpleHeader } from "@pepdirect/ui/SimpleHeader";
import { NavFooter } from "components/Footer/Checkout";
import { BrandConfigCustomizationsImage } from "services/graphql/generated";
import st from "./checkoutPageContainer.module.scss";

interface CheckoutPageContainerProps {
  children: ReactNode;
  title: string;
}

export const CheckoutPageContainer: FC<CheckoutPageContainerProps> = ({
  children,
  title,
}) => {
  const { tenant } = useContext(AppContext);

  const fallbackUrl = tenant?.fallbackUrl || "";
  const logo =
    tenant?.brandConfig?.customizations?.images?.find(
      (img: BrandConfigCustomizationsImage) => img.name === "logoLargeLightUrl"
    ) || null;

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <div className={st.pageWrapper}>
        <SimpleHeader
          fallbackUrl={fallbackUrl}
          logo={{ src: logo?.src || "", alt: logo?.alt || "Shop logo" }}
        />
        {children}
      </div>
      <NavFooter />
    </>
  );
};
